import { render } from "./ExpandableContent.vue?vue&type=template&id=55bca324&scoped=true&ts=true"
import script from "./ExpandableContent.ts?vue&type=script&lang=ts&external"
export * from "./ExpandableContent.ts?vue&type=script&lang=ts&external"

import "./ExpandableContent.scss?vue&type=style&index=0&id=55bca324&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bca324"]])

export default __exports__